var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.$store.getters.isOturum)?_c('Header'):_vm._e(),_vm._v(" "),_c('router-view'),_vm._v(" "),(this.$store.getters.isOturum)?_c('Footer'):_vm._e(),_vm._v(" "),(_vm.Logo)?_c('div',{staticClass:"bgLogo",style:('background-image:url(https://cdn.mudu.pro/Drive/upload/1/Genel/'+_vm.Logo+')')}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a548aca","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1383
// module chunks = 0